import { render, staticRenderFns } from "./LicenseWriteLink.vue?vue&type=template&id=215895a9&scoped=true&"
import script from "./LicenseWriteLink.vue?vue&type=script&lang=js&"
export * from "./LicenseWriteLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215895a9",
  null
  
)

export default component.exports